import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Flex, M } from 'design-system-web';
import {
  TeamCoverageEntry,
  formatDays,
  formatTimeDisplay,
} from './coverageHoursTeamUtils';
import styles from './CreateCoverageHoursPanel.scss';

type TeamCoverageCardProps = {
  entry: TeamCoverageEntry;
  onEdit: () => void;
  disabled: boolean;
};

export function TeamCoverageCard({
  entry,
  onEdit,
  disabled,
}: TeamCoverageCardProps) {
  const { t } = useTranslation();

  return (
    <Flex direction="column" className={styles.teamCard}>
      <Flex justify="space-between" align="center">
        <M className={styles.teamCardName}>{entry.teamLabel}</M>
        <Button variant="text" onClick={onEdit} disabled={disabled}>
          {t('web.admin.serviceRequest.settings.coverageHours.create.edit')}
        </Button>
      </Flex>
      {entry.coverageBlocks.map((block, i) => (
        <M key={i} className={styles.teamCardSchedule}>
          {formatDays(block.daysOfWeek)}, {formatTimeDisplay(block.startTime)}-{formatTimeDisplay(block.endTime)}
        </M>
      ))}
    </Flex>
  );
}
